<template>
  <div class="monitoringData mainPageBg">
    <div class="selectBox">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="配电房">
          <el-select v-model="formInline.room">
            <el-option label="配电房1" value="配电房1"></el-option>
            <el-option label="配电房2" value="配电房2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变压器">
          <el-select v-model="formInline.transformer">
            <el-option label="变压器1" value="变压器1"></el-option>
            <el-option label="变压器2" value="变压器2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="contentBox">
      <div class="itemWrap" v-for="(v, i) in dataList" :key="i">
        <h4>{{ v.code }}</h4>
        <ul class="detailsWrap">
          <li v-for="(item, index) in v.childen" :key="index">
            <div class="topWrap">
              <div :class="{ titleWrap: i !== 0, tolTitle: i === 0 }">
                <p>{{ item.title }}</p>
                <p v-if="v.tem">温度: {{ v.tem }}</p>
              </div>
              <div :class="{ imgBox: i !== 0, tolImg: i === 0 }">
                <img
                  :src="i === 0 ? url : v.childen.length > 1 ? url2 : url1"
                />
              </div>
            </div>
            <div class="dataWrap">
              <div
                v-for="value in item.data"
                :key="value.name"
                :class="{ dataUl: i !== 0, tolDataUl: i === 0 }"
              >
                <p v-if="i === 0">{{ value.name }}</p>
                <p>{{ value.num }}</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: require("@/assets/images/xitong/line.png"),
      url1: require("@/assets/images/xitong/line2.png"),
      url2: require("@/assets/images/xitong/line3.png"),
      dataList: [
        {
          code: "P01",
          tem: "25℃",
          childen: [
            {
              title: "专变进线",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
          ],
        },
        {
          code: "P02",
          childen: [
            {
              title: "无功补偿",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
          ],
        },
        {
          code: "P03",
          childen: [
            {
              title: "无功补偿",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
          ],
        },
        {
          code: "P05",
          childen: [
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "9-10层照明",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
          ],
        },
        {
          code: "P06",
          childen: [
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "9-10层照明",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
          ],
        },
        {
          code: "P07",
          childen: [
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "9-10层照明",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
          ],
        },
        {
          code: "P08",
          childen: [
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "备用",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
            {
              title: "9-10层照明",
              data: [
                { name: "la", num: "720.0A" },
                { name: "lb", num: "680.0A" },
                { name: "lc", num: "633.0A" },
                { name: "Uab", num: "390V" },
                { name: "Ubc", num: "392V" },
                { name: "Uca", num: "391V" },
                { name: "P", num: "452.9kW" },
                { name: "PE", num: "0.98" },
                { name: "EA", num: "6655.23kW" },
              ],
            },
          ],
        },
      ],
      formInline: {
        room: "配电房1",
        transformer: "变压器1",
      },
    };
  },
  methods: {
    onSubmit() {},
  },
};
</script>

<style lang="scss" scoped>
.monitoringData {
  background: #192a40;
  @include setFlexColumn;
  justify-content: space-around;
  align-items: center;
  .selectBox {
    width: 96%;
    height: 10%;
    @include setFlexStart;
    ::v-deep .el-form {
      .el-form-item__label {
        color: #fff;
      }
      .el-input {
        input {
          background: #12374f;
          color: #fff;
          border-color: #185b8b;
        }
      }
    }
  }
  .contentBox {
    width: 96%;
    height: 83%;
    border: 1px solid #16354e;
    color: #fff;
    @include setFlexStart;
    overflow-y: auto;
    .itemWrap {
      height: 100%;
      // border-right: 1px solid #0984e9;
      border-right: 1px solid #16354e;
      h4 {
        @include setFlexCenter;
        // width: 100px;
        height: 7%;
        border: 1px solid #185b8b;
        background: #203b59;
        border-right: none;
      }
      ul {
        height: 92%;
        @include setFlexStart;
        li {
          width: 120px;
          height: 100%;
          .topWrap {
            width: 100%;
            height: 45%;
            background: #17283d;
            .titleWrap,
            .tolTitle {
              width: 100%;
              height: 30%;
              @include setFlexColumn;
              align-items: center;
              justify-content: flex-end;
              border-bottom: 2px solid #7bf4f8;
              p {
                margin-bottom: 15px;
              }
            }
            .tolTitle {
              align-items: center;
              border: none;
              p {
                margin-top: 15px;
              }
            }

            .imgBox,
            .tolImg {
              width: 100%;
              height: 70%;
              @include setFlexCenter;
              img {
                height: 100%;
              }
            }
            .tolImg {
              border-bottom: 2px solid #7bf4f8;
              border-right: 2px solid #7bf4f8;
            }
          }
          .dataWrap {
            width: 100%;
            height: 54%;
            .dataUl {
              height: 10%;
              width: 90%;
              margin: 0 auto;
              font-size: 13px;
              @include setFlexColumn;
              justify-content: space-around;
              align-items: center;
            }
            .tolDataUl {
              height: 10%;
              width: 90%;
              margin: 0 auto;
              font-size: 13px;
              @include setFlexBetween;
              p:nth-child(1) {
                color: #7bf4f8;
              }
            }
          }
        }
      }
    }
    // .itemWrap:nth-child(-n + 3) {
    //   width: 10%;
    // }
    .itemWrap:last-child {
      border: none;
    }
  }
}
</style>